const initialAuthState = { language: "en" };

const reducer = (state = initialAuthState, action = []) => {
  return state;
};

export default reducer;
